import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Theater } from '../../models/theater.model';

interface TheaterState {
    theaters: Theater[];
    currentTheater: Theater | null;
    loading: boolean;
}

const initialState: TheaterState = {
    theaters: [],
    currentTheater: null,
    loading: false,
};

const theaterSlice = createSlice({
    name: 'theater',
    initialState,
    reducers: {
        // Get all theaters
        getAllTheaters: (state) => {
            state.loading = true;
        },
        getAllTheatersSuccess: (state, action: PayloadAction<Theater[]>) => {
            state.loading = false;
            state.theaters = action.payload;
        },
        getAllTheatersFailed: (state) => {
            state.loading = false;
        },
        // Get theater by ID
        getTheaterById: (state) => {
            state.loading = true;
        },
        getTheaterByIdSuccess: (state, action: PayloadAction<Theater>) => {
            state.loading = false;
            state.currentTheater = action.payload;
        },
        getTheaterByIdFailed: (state) => {
            state.loading = false;
        },
        // Create theater
        createTheater: (state) => {
            state.loading = true;
        },
        createTheaterSuccess: (state, action: PayloadAction<Theater>) => {
            state.loading = false;
            state.theaters = [action.payload, ...state.theaters];
            state.currentTheater = action.payload;
        },
        createTheaterFailed: (state) => {
            state.loading = false;
        },
        // Update theater
        updateTheater: (state) => {
            state.loading = true;
        },
        updateTheaterSuccess: (state, action: PayloadAction<Theater>) => {
            state.loading = false;
            state.theaters = state.theaters.map(theater =>
                theater._id === action.payload._id ? action.payload : theater
            );
            state.currentTheater = action.payload;
        },
        updateTheaterFailed: (state) => {
            state.loading = false;
        },
        // Delete theater
        deleteTheater: (state) => {
            state.loading = true;
        },
        deleteTheaterSuccess: (state, action: PayloadAction<Theater>) => {
            state.loading = false;
            state.theaters = state.theaters.filter(theater => theater._id !== action.payload._id);
            state.currentTheater = null;
        },
        deleteTheaterFailed: (state) => {
            state.loading = false;
        },
        // Get theaters by location
        getTheatersByLocation: (state) => {
            state.loading = true;
        },
        getTheatersByLocationSuccess: (state, action: PayloadAction<Theater[]>) => {
            state.loading = false;
            state.theaters = action.payload;
        },
        getTheatersByLocationFailed: (state) => {
            state.loading = false;
        },
        // Get theater by name
        getTheaterByName: (state) => {
            state.loading = true;
        },
        getTheaterByNameSuccess: (state, action: PayloadAction<Theater>) => {
            state.loading = false;
            state.currentTheater = action.payload;
        },
        getTheaterByNameFailed: (state) => {
            state.loading = false;
        },
    },
});

export const {
    getAllTheaters,
    getAllTheatersSuccess,
    getAllTheatersFailed,
    getTheaterById,
    getTheaterByIdSuccess,
    getTheaterByIdFailed,
    createTheater,
    createTheaterSuccess,
    createTheaterFailed,
    updateTheater,
    updateTheaterSuccess,
    updateTheaterFailed,
    deleteTheater,
    deleteTheaterSuccess,
    deleteTheaterFailed,
    getTheatersByLocation,
    getTheatersByLocationSuccess,
    getTheatersByLocationFailed,
    getTheaterByName,
    getTheaterByNameSuccess,
    getTheaterByNameFailed,
} = theaterSlice.actions;

export default theaterSlice.reducer;